export const USER_FIRST_NAME_PLACEHOLDER = '%vorname%';

export const USER_LAST_NAME_PLACEHOLDER = '%nachname%';

export const USER_EMAIL_PLACEHOLDER = '%email%';
